import React from "react";
import { Pagination } from "antd";
import { pagination } from "../../Tasks/configs/designTokens";

const PAGE_SIZES = pagination.pageSizes;

const CreativePagination = ({
  current,
  pageSize,
  total,
  onChange,
  onPageSizeChange,
  compact,
}) => {
  const start = (current - 1) * pageSize + 1;
  const end = Math.min(current * pageSize, total);

  if (total <= 0) return null;

  return (
    <div
      className={`creative-pagination${
        compact ? " creative-pagination--compact" : ""
      }`}
    >
      {!compact && (
        <div className="creative-pagination__left">
          <span className="creative-pagination__summary">
            Showing <strong>{start}</strong> - <strong>{end}</strong> of{" "}
            <strong>{total}</strong>
          </span>
        </div>
      )}

      <div className="creative-pagination__center">
        <Pagination
          current={current}
          pageSize={pageSize}
          total={total}
          showSizeChanger={false}
          hideOnSinglePage={false}
          onChange={(page) => onChange(page)}
          className="creative-pagination__nav"
        />
      </div>

      <div className="creative-pagination__right">
        <span className="creative-pagination__size-label">Show:</span>
        <div className="creative-pagination__size-options">
          {PAGE_SIZES.map((size) => (
            <button
              key={size}
              className={`creative-pagination__size-btn${
                pageSize === size
                  ? " creative-pagination__size-btn--active"
                  : ""
              }`}
              onClick={() => onPageSizeChange(size)}
            >
              {size}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreativePagination;
